const menuItems = document.querySelectorAll('.nav-item.has-treeview')

for(const item of menuItems) {
  item.addEventListener('click', () => {
    if (![...item.classList].includes('menu-open')) {
      return
    }

    item.classList.remove('menu-is-opening', 'menu-open')
  })

  if ([...item.classList].includes('menu-open')) {
    item.classList.add('menu-is-opening')
    item.querySelector('ul').style.display = 'block'
  }
}
